import { Add, Delete, Edit, SearchOutlined } from "@mui/icons-material";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, InputBase, Tooltip, Typography } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect, useMemo, useRef, useState } from "react";
import { DeleteQuestionnary, GetAllCerboTags, GetAllCRMTags, GetAllCustomFields, GetQuestionnariesMappings } from "../../Service/AxiosService";
import AddQuestionnaire from "./AddQuestionnaire";

const QuestionnaireList = () => {
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
  const [row, setRow] = useState<any[]>([]);
  const [tag, setTag] = useState<any[]>([]);
  const [open, setOpen] = useState(false);
  const [editRow, setEditRow] = useState<any>(null);
  const [deleteRow, setDeleteRow] = useState<any>(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [cerboTag, setCerboTag] = useState<any[]>([]);
  const [customFields, setCustomFields] = useState<{ fieldId: string; fieldName: string }[]>([]);
  const [searchTerm, setSearchTerm] = useState('');

  const columns: GridColDef[] = [
    { field: 'S_No', headerName: 'S.No', width: 20, headerAlign: 'center', align: 'center' },
    {
      field: 'questionnaireDetails',
      headerName: 'Questionnaire',
      flex: 1,
      minWidth: 150,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => (
        <Tooltip title={params.value} placement="top" arrow>
          <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', width: '100%' }}>
            {params.value}
          </span>
        </Tooltip>
      ),
    },
    //{ field: 'enabletag', headerName: 'Enable Tag Condition', width: 200, headerAlign: 'center', align: 'center' },
    {
      field: 'conditionTag',
      headerName: 'Required Cerbo Tag',
      flex: 1,
      minWidth: 150,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => (
        <Tooltip title={params.value} placement="top" arrow>
          <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', width: '100%' }}>
            {params.value}
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'AddcerbotagName',
      headerName: 'Add Cerbo Tags',
      flex: 1,
      minWidth: 150,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => (
        <Tooltip title={params.value} placement="top" arrow>
          <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', width: '100%' }}>
            {params.value}
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'RemoveCerboTags',
      headerName: 'Remove Cerbo Tags',
      flex: 1,
      minWidth: 150,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => (
        <Tooltip title={params.value} placement="top" arrow>
          <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', width: '100%' }}>
            {params.value}
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'AddCrmTagName',
      headerName: 'Add HL Tags',
      flex: 1,
      minWidth: 150,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => (
        <Tooltip title={params.value} placement="top" arrow>
          <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', width: '100%' }}>
            {params.value}
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'RemoveCrmTagName',
      headerName: 'Remove HL Tags',
      flex: 1,
      minWidth: 150,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => (
        <Tooltip title={params.value} placement="top" arrow>
          <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', width: '100%' }}>
            {params.value}
          </span>
        </Tooltip>
      ),
    },

    // {
    //   field: 'cerboTagEntityValue',
    //   headerName: 'Cerbo Tag Value',
    //   flex: 1,
    //   minWidth: 150,
    //   headerAlign: 'left',
    //   align: 'left',
    //   renderCell: (params) => (
    //     <Tooltip title={params.value} placement="top" arrow>
    //       <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', width: '100%' }}>
    //         {params.value}
    //       </span>
    //     </Tooltip>
    //   ),
    // },
    {
      field: 'CustomField',
      headerName: 'Custom Field',
      flex: 1.2,
      minWidth: 150,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => (
        <Tooltip title={params.value} placement="top" arrow>
          <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', maxWidth: '100%' }}>
            {params.value}
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'CustomFieldValueNew',
      headerName: 'Custom Field Value',
      flex: 1.2,
      minWidth: 150,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => (
        <Tooltip title={params.value} placement="top" arrow>
          <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', maxWidth: '100%' }}>
            {params.value}
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'CerboNotesTag',
      headerName: 'Cerbo Notes Tag',
      flex: 1.2,
      minWidth: 150,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => (
        <Tooltip title={params.value} placement="top" arrow>
          <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', maxWidth: '100%' }}>
            {params.value}
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'CerboTagNotes',
      headerName: 'Cerbo Tag Notes',
      flex: 1.2,
      minWidth: 150,
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => (
        <Tooltip title={params.value} placement="top" arrow>
          <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', maxWidth: '100%' }}>
            {params.value}
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 100,
      minWidth: 100,
      maxWidth: 100,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      filterable: false,
      disableReorder: true,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <IconButton
            aria-label="edit"
            color="primary"
            size="small"
            onClick={() => { setEditRow(params.row); setOpen(true); }}
          >
            <Edit sx={{fontSize: 15}} />
          </IconButton>
          <IconButton
            aria-label="delete"
            color="error"
            size="small"
          onClick={() => handleDelete(params.row)}
          >
            <Delete sx={{fontSize: 15}} />
          </IconButton>
        </Box>
      ),
    },
  ];

  const dataGridWrapperRef = useRef<HTMLDivElement>(null);
  const ROW_HEIGHT = 40;

  useEffect(() => {
    document.title = `${process.env.REACT_APP_CLINIC_NAME || 'Clinic'} - Questionnaires`;

    if (!dataGridWrapperRef.current) return;
    const observer = new ResizeObserver(() => {
      const newPageSize = calculatePageSize(dataGridWrapperRef.current!);
      setPaginationModel(prev => {
        if (prev.pageSize === newPageSize) return prev;
        return { ...prev, pageSize: newPageSize, page: 0 };
      });
    });
    observer.observe(dataGridWrapperRef.current);
    return () => observer.disconnect();
  }, []);

  const QuestionnariesMappings = async () => {
    let cerboFormattedTag: any[] = [];
      const cerboTags = await GetAllCerboTags();
      const rawCerbo = cerboTags?.data ?? cerboTags;
      const cerboData: any[] = Array.isArray(rawCerbo)
        ? rawCerbo
        : Array.isArray(rawCerbo?.data)
        ? rawCerbo.data
        : [];

      cerboFormattedTag = cerboData.map((tag: any) => ({ id: tag.id, name: `${tag.tagCategory} - ${tag.name}` }));
      setCerboTag(cerboFormattedTag);
      if (cerboTags && cerboTags.success === false) {
        alert(cerboTags.error || 'Failed to fetch cerbo tags');
      }

      let formattedTag: any[] = [];
      const tags = await GetAllCRMTags();
      if (tags.success && tags.data) {
        formattedTag = tags.data.map((tag: any) => ({ id: tag.tagId, name: tag.tagName }));
        setTag(formattedTag);
      } else {
        alert(tags.error || 'Failed to fetch tags');
        setTag([]);
      }

      const csFields = await GetAllCustomFields();
      if (csFields.success && csFields.data) {
        setCustomFields(csFields.data.map((f: any) => ({ fieldId: f.fieldId, fieldName: f.fieldName })));
      }

      const res = await GetQuestionnariesMappings();
      const rawData = res?.data ?? res;
      const questionnairesData: any[] = Array.isArray(rawData)
        ? rawData
        : Array.isArray(rawData?.data)
        ? rawData.data
        : [];
      if (res.success && questionnairesData.length > 0) {
        const formattedData = questionnairesData.map((item: any, index: number) => ({
          id: item.id || `questionnaire-${index}-${Date.now()}`,
          questionnaireDetails: item.questionnaryText,
          S_No: index + 1,
          enableTag: item.enableTagCondition ? 'Enabled' : 'Disabled',
          conditionTag: item.conditionTags ? cerboFormattedTag.filter(tag => item.conditionTags.split(',').includes(tag.id)).map(tag => tag.name).join(', ') : '',
          conditionTagIds: item.conditionTags || '',
          AddcerbotagName: item.cerboAddTags ? cerboFormattedTag.filter(tag => item.cerboAddTags.split(',').includes(tag.id)).map(tag => tag.name).join(', ') : '',
          cerboAddTagIds: item.cerboAddTags || '',
          RemoveCerboTags: item.cerboRemoveTags ? cerboFormattedTag.filter(tag => item.cerboRemoveTags.split(',').includes(tag.id)).map(tag => tag.name).join(', ') : '',
          cerboRemoveTagIds: item.cerboRemoveTags || '',
          AddCrmTagName: item.crmAddTags ? formattedTag.filter(tag => item.crmAddTags.split(',').includes(tag.id)).map(tag => tag.name).join(', ') : '',
          crmAddTagIds: item.crmAddTags || '',
          RemoveCrmTagName: item.crmRemoveTags ? formattedTag.filter(tag => item.crmRemoveTags.split(',').includes(tag.id)).map(tag => tag.name).join(', ') : '',
          crmRemoveTagIds: item.crmRemoveTags || '',
          CustomField: item.customFieldId ? csFields.data?.find((f : any) => f.fieldId === item.customFieldId)?.fieldName || '' : '',
          CustomFieldValueNew: item.customFieldValue || '',
          CustomFieldId: item.customFieldId || '',
          CerboNotesTag: item.cerboNotesTagId ? cerboFormattedTag.find(tag => tag.id === item.cerboNotesTagId)?.name || '' : '',
          CerboTagNotes: item.cerboTagNotes || '',
          cerboNotesTagId: item.cerboNotesTagId || '',
        }));
        setRow(formattedData);
      } else {
        setRow([]);
      }
    }

  useEffect(() => {
    
    QuestionnariesMappings();
  }, []);

  const pageSizeOptions = useMemo(() => [5, 10, 20, 50, paginationModel.pageSize].filter((v, i, arr) => arr.indexOf(v) === i).sort((a, b) => a - b), [paginationModel.pageSize]);

  const filteredRows = useMemo(() => {
    if (!searchTerm.trim()) return row;
    const term = searchTerm.toLowerCase();
    return row.filter((r) =>
      r.questionnaireDetails?.toLowerCase().includes(term) ||
      r.conditionTag?.toLowerCase().includes(term) ||
      r.AddcerbotagName?.toLowerCase().includes(term) ||
      r.RemoveCerboTags?.toLowerCase().includes(term) ||
      r.AddCrmTagName?.toLowerCase().includes(term) ||
      r.RemoveCrmTagName?.toLowerCase().includes(term) ||
      r.CustomField?.toLowerCase().includes(term) ||
      r.CustomFieldValueNew?.toLowerCase().includes(term) ||
      r.CerboNotesTag?.toLowerCase().includes(term) ||
      r.CerboTagNotes?.toLowerCase().includes(term)
    );
  }, [row, searchTerm]);

  const calculatePageSize = (gridEl: HTMLDivElement) => {
    const header = gridEl.querySelector('.MuiDataGrid-columnHeaders');
    const footer = gridEl.querySelector('.MuiDataGrid-footerContainer');

    const headerHeight = header?.getBoundingClientRect().height ?? 0;
    const footerHeight = footer?.getBoundingClientRect().height ?? 0;
    const gridHeight = gridEl.getBoundingClientRect().height;

    const availableHeight = gridHeight - headerHeight - footerHeight;
    const rowsThatFit = Math.floor(availableHeight / ROW_HEIGHT);

    return Math.max(5, rowsThatFit);
  };

 const handleOnClose = async () => {
    setEditRow(null);
    setOpen(false);
    await QuestionnariesMappings();
  };

   const handleDelete = (row: any) => {
        setDeleteRow(row);
        setDeleteDialogOpen(true);
      };
    
      const handleConfirmDelete = async () => {
        if (deleteRow?.id) {
          await DeleteQuestionnary(deleteRow.id);
           await QuestionnariesMappings();
        }
        setDeleteDialogOpen(false);
        setDeleteRow(null);
    };

  return (
    <Box sx={{ width: '100%', height: '100%', p: 0, m: 0, bgcolor: 'transparent', display: 'flex', flexDirection: 'column' }}>
        <Grid container alignItems="center" justifyContent="space-between" sx={{ mb: 1, mt: 0.5 }}>
          <Grid>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: 17,
              }}
              variant="subtitle1"
            >
              Questionnaires
            </Typography>
          </Grid>
          <Grid>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  width: 300,
                  bgcolor: '#fff',
                  height: 36,
                  border: '1px solid #dedede',
                  borderRadius: 2,
                }}
              >
                <InputBase
                  placeholder="Search questionnaires..."
                  inputProps={{ 'aria-label': 'search questionnaires' }}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  sx={{
                    flex: 1,
                    fontSize: 15,
                    bgcolor: 'transparent',
                    px: 2,
                    py: 0.5,
                    height: 32,
                  }}
                />
                <IconButton sx={{ p: '4px', color: '#23244A', height: 32, width: 32 }} aria-label="search" size="small">
                  <SearchOutlined fontSize="small" />
                </IconButton>
              </Box>
              <Button
                variant="contained"
                color="primary"
                startIcon={<Add fontSize="small" />}
                sx={{
                  textTransform: 'none',
                  boxShadow: 'none',
                  bgcolor: '#3D52A0',
                  '&:hover': { bgcolor: '#31417f' },
                  fontSize: 14,
                  borderRadius: 2,
                  minWidth: 120,
                  py: 1,
                  px: 2,
                  height: 36,
                }}
              onClick={() => setOpen(true)}
              >
                New Questionnaire Rule
              </Button>
            </Box>
          </Grid>
        </Grid>
      <Box ref={dataGridWrapperRef} 
        sx={{
          flex: 1,
          width: '100%',
          minHeight: 0,
          pb: 0,
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
          bgcolor: '#fff',
          borderRadius: 3,
          boxShadow: '0 2px 16px rgba(24,26,42,0.08)',
        }}>
        <DataGrid
          rows={filteredRows}
          columns={columns}
          pagination
          pageSizeOptions={pageSizeOptions}
          rowHeight={ROW_HEIGHT}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          sx={{
            borderRadius: 3,
            bgcolor: '#fff',
            fontSize: 13,
            flex: 1,
            boxShadow: 'none',
            '& .MuiDataGrid-columnHeaders': {
              bgcolor: '#FAFAFC',
              fontWeight: 700,
              fontSize: 13,
              borderTopLeftRadius: 12,
              borderTopRightRadius: 12,
              '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 700,
              }
            },
            '& .MuiDataGrid-cell': { fontSize: 12, py: 0, color: '#000' },
            '& .MuiDataGrid-row': { minHeight: 32, maxHeight: 32 },
            '& .MuiDataGrid-virtualScroller': { overflowX: 'auto !important' },
            '& .MuiTablePagination-root': { fontSize: 12, borderTop: '1px solid #e0e0e0' },
            '& .MuiDataGrid-footerContainer': {
              bgcolor: '#FAFAFC',
              borderBottomLeftRadius: 12,
              borderBottomRightRadius: 12,
            },
            '& .MuiDataGrid-selectedRowCount': { color: '#23244A' },
            '& .MuiDataGrid-cell--textRight, & .MuiDataGrid-cell[data-field="actions"]': {
              position: 'sticky',
              right: 0,
              backgroundColor: '#fff',
              zIndex: 3,
            },

            '& .MuiDataGrid-columnHeader[data-field="actions"]': {
              position: 'sticky',
              right: 0,
              backgroundColor: '#FAFAFC',
              zIndex: 4,
            },
          }}
        />
      </Box>
      <Dialog open={open} onClose={handleOnClose} maxWidth="sm" fullWidth>
        <AddQuestionnaire 
        open={open} 
        onClose={handleOnClose} 
        TagList={tag} 
        initialvalues={editRow}
        cerboTags={cerboTag}
        customFields={customFields}
        tagListForNotes={cerboTag}
        />
      </Dialog>
      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}
        PaperProps={{
          sx: {
            borderRadius: 3,
            background: '#FAFAFC',
            boxShadow: '0 2px 16px rgba(24,26,42,0.10)',
            minWidth: 320,
          }
        }}
      >
        <DialogTitle sx={{ fontSize: 16, fontWeight: 700 }}>
          Confirm Delete
        </DialogTitle>
        <DialogContent sx={{ fontSize: 15, maxHeight: "80vh", overflowY: "auto" }}>
          Are you sure you want to delete this Questionnary mapping?
        </DialogContent>
        <DialogActions sx={{ py: 2, px: 3 }}>
          <Button onClick={() => setDeleteDialogOpen(false)} color="secondary" variant="outlined" size="small"
            sx={{
              borderRadius: 2,
              border: 'none',
              background: '#dedede',
              color: '#000',
              textTransform: 'capitalize',
              py: 1,
              px: 2,
              '&:hover': { background: '#d6d6d6' },
            }}
          >
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="error" variant="contained" size="small"
            sx={{
              borderRadius: 2,
              background: '#d32f2f',
              textTransform: 'capitalize',
              py: 1,
              px: 2,
              '&:hover': { background: '#b71c1c' }
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
};
export default QuestionnaireList;